import { Box } from '@material-ui/core'
import FilledButton from '../../components/FilledButton'
import ValidateRow from '../../components/ValidateRow'
import urlEnlightenStrings from '../../utils/urlEnlightenStrings'
import { useStyles } from './styles'
const ValidateForm = (props) => {
  const {
    confirmed,
    rejected,
    unenrolled,
    site,
    approvedRowCount,
    setApprovedRowCount,
    reviewedRowCount,
    setReviewedRowCount,
  } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Box className={classes.enlighten}>
        <FilledButton
          label="Open Site Details on Enlighten"
          enlightentab={true}
          onClick={() => {
            window.open(
              urlEnlightenStrings.getApiUrl(
                `web/${site?.site_id}/today/graph/hours`,
              ),
              '_blank',
            )
          }}
        ></FilledButton>
      </Box>
      {confirmed || rejected || unenrolled ? (
        confirmed ? (
          <Box className={classes.form}>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Name of customer"
              fieldvalue={site?.name}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Address"
              fieldvalue={site?.address}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Phone Number"
              fieldvalue={site?.phone_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Site ID"
              fieldvalue={site?.site_id}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="kW Capacity Committed for dispatch"
              fieldvalue={site?.dispatch_capacity}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Dispatch Timings"
              fieldvalue={`${site?.dispatch_starttime} PM to ${site?.dispatch_endtime} PM`}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Underlying Program"
              fieldvalue={site?.program?.toUpperCase()}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="$/kW bucket that was sanctioned"
              fieldvalue={site?.rate}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Electric Account Number"
              fieldvalue={site?.electric_account_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Name of Installer"
              fieldvalue={site?.installer_name}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              confirmed={confirmed}
              fieldkey="Electric Meter Number"
              fieldvalue={site?.electric_meter_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
          </Box>
        ) : rejected ? (
          <Box className={classes.form}>
            <ValidateRow
              rejected={rejected}
              fieldkey="Name of customer"
              fieldvalue={site?.name}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Address"
              fieldvalue={site?.address}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Phone Number"
              fieldvalue={site?.phone_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Site ID"
              fieldvalue={site?.site_id}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="kW Capacity Committed for dispatch"
              fieldvalue={site?.dispatch_capacity}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Dispatch Timings"
              fieldvalue={`${site?.dispatch_starttime} PM to ${site?.dispatch_endtime} PM`}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Underlying Program"
              fieldvalue={site?.program?.toUpperCase()}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="$/kW bucket that was sanctioned"
              fieldvalue={site?.rate}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Electric Account Number"
              fieldvalue={site?.electric_account_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Name of Installer"
              fieldvalue={site?.installer_name}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              rejected={rejected}
              fieldkey="Electric Meter Number"
              fieldvalue={site?.electric_meter_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
          </Box>
        ) : unenrolled ? (
          <Box className={classes.form}>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Name of customer"
              fieldvalue={site?.name}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Address"
              fieldvalue={site?.address}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Phone Number"
              fieldvalue={site?.phone_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Site ID"
              fieldvalue={site?.site_id}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="kW Capacity Committed for dispatch"
              fieldvalue={site?.dispatch_capacity}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Dispatch Timings"
              fieldvalue={`${site?.dispatch_starttime} PM to ${site?.dispatch_endtime} PM`}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Underlying Program"
              fieldvalue={site?.program?.toUpperCase()}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="$/kW bucket that was sanctioned"
              fieldvalue={site?.rate}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Electric Account Number"
              fieldvalue={site?.electric_account_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Name of Installer"
              fieldvalue={site?.installer_name}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
            <ValidateRow
              unenrolled={unenrolled}
              fieldkey="Electric Meter Number"
              fieldvalue={site?.electric_meter_number}
              reviewedRowCount={reviewedRowCount}
              setReviewedRowCount={setReviewedRowCount}
              approvedRowCount={approvedRowCount}
              setApprovedRowCount={setApprovedRowCount}
            ></ValidateRow>
          </Box>
        ) : null
      ) : (
        <Box className={classes.form}>
          <ValidateRow
            fieldkey="Name of customer"
            fieldvalue={site?.name}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Address"
            fieldvalue={site?.address}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Phone Number"
            fieldvalue={site?.phone_number}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Site ID"
            fieldvalue={site?.site_id}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="kW Capacity Committed for dispatch"
            fieldvalue={site?.dispatch_capacity}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Dispatch Timings"
            fieldvalue={`${site?.dispatch_starttime} PM to ${site?.dispatch_endtime} PM`}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Underlying Program"
            fieldvalue={site?.program?.toUpperCase()}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="$/kW bucket that was sanctioned"
            fieldvalue={site?.rate}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Electric Account Number"
            fieldvalue={site?.electric_account_number}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Name of Installer"
            fieldvalue={site?.installer_name}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
          <ValidateRow
            fieldkey="Electric Meter Number"
            fieldvalue={site?.electric_meter_number}
            reviewedRowCount={reviewedRowCount}
            setReviewedRowCount={setReviewedRowCount}
            approvedRowCount={approvedRowCount}
            setApprovedRowCount={setApprovedRowCount}
          ></ValidateRow>
        </Box>
      )}
    </div>
  )
}
export default ValidateForm
